<template>
  <certificateDetail
    :listData="officialData"
    :title="$t('certificate_official_1')"
    :authority="authority"
    @handleItem="handleItem"
  ></certificateDetail>
</template>

<script>
import certificateDetail from '../compontent/certificate-detail'
export default {
  components: { certificateDetail },
  data() {
    return {
      officialData: [
        // 列表配置数据 名称中可能含有数字，所以使用｜将对应字段与名字区分开
        {
          title: this.$t('certificate_official_2'),
          list: [
            {
              // PND1
              icon: require('@/assets/img/icon-PND1.png'),
              name: this.$t('certificate_official_4'),
              txt: this.$t('certificate_official_5'),
              path: '/certificate/detail-official/1'
            },
            {
              // PND3
              icon: require('@/assets/img/icon-PND3.png'),
              name: this.$t('certificate_official_6'),
              txt: this.$t('certificate_official_7'),
              path: '/certificate/detail-official/2'
            },
            {
              // PND1 Kor
              icon: require('@/assets/img/icon-PND1Kor.png'),
              name: this.$t('certificate_official_8'),
              txt: this.$t('certificate_official_9'),
              path: '/certificate/detail-official/3'
            }
          ]
        },
        {
          title: this.$t('certificate_official_3'),
          list: [
            {
              // SorPorSor1-10
              icon: require('@/assets/img/icon-SorPorSor1-10.png'),
              name: this.$t('certificate_official_10'),
              txt: this.$t('certificate_official_11'),
              path: '/certificate/detail-official/4'
            }
          ]
        }
      ],
      authority: {
        export: this.$p('menu.certificate.official.export')
      },
      itemData: { cItem: {} }
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.title = (this.itemData.cItem && this.itemData.cItem.name) || to.meta.title
    next()
  },
  methods: {
    handleItem(item) {
      this.itemData = item
      this.$router.push(item.cItem.path)
    }
  }
}
</script>

<style lang="scss" scoped></style>
